import { useEffect, useMemo, useState } from "react";
import useSelect from "~components/Form/hooks/useSelect";

import { db } from "~/db/db";
import prepareForOptions from "~services/utils/prepareForOptions";
import { getColumnIntoKey } from "~pages/PriceSearchV2/utils/initializerHelpers";

const usePesquisaCentroOrigem = ({ formikRef, pesquisaPlayerId = 0 }) => {
  const pesquisaCentroOrigemSelect = useSelect("pesquisaCentros");
  const [pesquisaCentroOrigem, setPesquisaCentroOrigem] = useState(0);
  const [pesquisaCentroOrigemObjeto, setPesquisaCentroOrigemObjeto] = useState({});
  const [fila, setFila] = useState(null);

  const [pesquisaCentros, setPesquisaCentros] = useState([]);
  const [pesquisaPlayerCentroOrigem, setPesquisaPlayerCentroOrigem] = useState([]);

  useEffect(() => {
    const fetchPesquisaCentros = async () => {
      const centros = [];
      await db.pesquisaCentroOrigem.each((centro) => {
        centros.push(centro);
      });
      setPesquisaCentros(centros);
    };

    const fetchPesquisaPlayerCentroOrigem = async () => {
      const players = [];
      await db.pesquisaPlayerCentroOrigem.each((player) => {
        players.push(player);
      });
      setPesquisaPlayerCentroOrigem(players);
    };

    fetchPesquisaCentros();
    fetchPesquisaPlayerCentroOrigem();
  }, []);

  const pesquisaPlayerCentroOrigens = useMemo(() => {
    const result = {};
    if (pesquisaPlayerCentroOrigem && pesquisaPlayerCentroOrigem.length > 0) {
      for (const e of pesquisaPlayerCentroOrigem) {
        result[e.pesquisaPlayerId + "/" + e.pesquisaCentroOrigemId] = true;
      }
    }
    return result;
  }, [pesquisaPlayerCentroOrigem]);

  const optionPesquisaCentroOrigem = useMemo(() => {
    let temp = [];
    if (pesquisaPlayerId && pesquisaPlayerId != 0) {
      temp = (pesquisaCentros || []).filter((e) => {
        return pesquisaPlayerId
          ? e.ativo &&
              Object.entries(pesquisaPlayerCentroOrigens).length > 0 &&
              pesquisaPlayerCentroOrigens[pesquisaPlayerId + "/" + e.id]
          : e;
      });
    }
    return prepareForOptions(temp, ["nome"], "id");
  }, [pesquisaPlayerCentroOrigens, pesquisaPlayerId]);

  useEffect(() => {
    if (
      fila &&
      pesquisaPlayerCentroOrigens &&
      Object.keys(pesquisaPlayerCentroOrigens).length > 0 &&
      optionPesquisaCentroOrigem &&
      optionPesquisaCentroOrigem.length > 0
    ) {
      setPesquisaCentroOrigemSelect(fila);
    }
  }, [fila, pesquisaPlayerCentroOrigens, optionPesquisaCentroOrigem]);

  useEffect(() => {
    if (pesquisaCentros?.length > 0)
      setPesquisaCentroOrigemObjeto(getColumnIntoKey({ data: pesquisaCentros, prefix: "id-" }));
  }, [pesquisaCentros]);

  function setPesquisaCentroOrigemSelect(value) {
    if (
      pesquisaCentros &&
      pesquisaCentros.length > 0 &&
      optionPesquisaCentroOrigem &&
      optionPesquisaCentroOrigem.length > 0
    ) {
      const optionCentro = (pesquisaCentros || []).find((opt) => opt.id == value);

      if (optionCentro) {
        onChangePesquisaCentroOrigem({
          label: optionCentro.nome,
          value: optionCentro.id,
        });
      }
      setFila(null);
    } else {
      setFila(value);
    }
  }

  function onChangePesquisaCentroOrigem(e) {
    pesquisaCentroOrigemSelect.upDateValue(e.value);
    pesquisaCentroOrigemSelect.upDateDefaultValue(e || "");
    const formikInstance = formikRef?.current;
    if (formikInstance) {
      formikInstance.setFieldValue("pesquisaCentroOrigemId", e.value);
      setTimeout(() => formikInstance.setFieldTouched("pesquisaCentroOrigemId", true));
    }

    setPesquisaCentroOrigem(e.value);
  }

  return {
    pesquisaCentroOrigemObjeto,
    pesquisaCentroOrigem,
    optionPesquisaCentroOrigem,
    onChangePesquisaCentroOrigem,
    pesquisaCentros,
    pesquisaCentroOrigemSelect,
    setPesquisaCentroOrigem,
    setPesquisaCentroOrigemSelect,
  };
};

export default usePesquisaCentroOrigem;
